import styled from '@emotion/styled';
import { mediaQueries, remCalc } from '../../css';

const StyledWrapper = styled('div')(() => ({
    position: 'relative',
    paddingBottom: '56.25%',
}));

const StyledSlide = styled('div')(({ isActive }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    transitionDuration: '500ms',
    transitionTimingFunction: 'cubic-bezier(.63, .24, .93, .2)',
    transitionProperty: 'opacity',
    opacity: isActive ? 1 : 0,
}));

const StyledLogo = styled('div')(() => ({
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: remCalc(10),
    justifyContent: 'flex-start',
    alignItems: 'center',
    zIndex: 20, // assert that we reasonably won't have more than 19 teasers
    [mediaQueries.medium]: {
        left: remCalc(35),
    },
}));

export { StyledLogo, StyledSlide, StyledWrapper };
